import styled from 'styled-components';

import S from '../UI/variables';

export const StyledFooter = styled.footer`
  background: #fff;
  padding: 5px 20px;
  max-width: 1320px;
  margin: 0 auto;
`;

export const StyledFooterWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: ${S.tablet}) {
    flex-direction: row;
    flex-wrap: wrap;
    & > li {
      width: 50%;
    }
  }
  @media screen and (min-width: ${S.desktop}) {
    flex-wrap: nowrap;
    & > li {
      flex-shrink: 0;
      width: 25%;
      &:nth-child(3) {
        width: 35%;
        padding-right: 30px;
        flex-grow: 2;
      }
      &:last-child {
        flex-shrink: 2;
      }
    }
  }
`;

export const StyledFooterItem = styled.li`
  width: 100%;
  padding: 14px 0 0;
  border-bottom: 1px solid ${S.mainBorder};
  position: relative;
  & > h2 {
    color: ${S.goldenText};
    font-family: 'Judson', serif;
    font-size: 14px;
    font-weight: 600;
    text-transform: lowercase;
    margin-bottom: 14px;
    &::first-letter {
      text-transform: uppercase;
    }
    @media screen and (min-width: ${S.tablet}) {
      font-size: 16px;
    }
  }
  & .text {
    color: ${S.footerGreyText};
    font-size: 14px;
    line-height: 2.2em;
    @media screen and (min-width: ${S.tablet}) {
      font-size: 16px;
    }
  }
  & .link {
    color: ${S.footerGreyText};
    line-height: 2.2em;
    cursor: pointer;
    &.underlined {
      text-decoration: underline;
    }
  }
  & > .plus_icon {
    position: absolute;
    right: 0;
    top: 12px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    padding: 6px;
    @media (min-width: ${S.tablet}) {
      display: none;
    }
    transition: transform ${S.trFast};
  }
`;

export const StyledFooterContent = styled.ul`
  overflow: hidden;
  padding-bottom: 14px;

  &.expandable {
    padding-bottom: 0;
    height: ${props => props.children.length * 30 + 14}px;
    &:not(.expanded) {
      height: 0;
      overflow: hidden;
    }
    &.expanded + .plus_icon {
      transform: rotate(-45deg);
    }
    @media screen and (min-width: ${S.tablet}) {
      &:not(.expanded),
      &.expanded {
        height: ${props => props.children.length * 35 + 14}px;
      }
    }
    transition: height ${S.trFast} 250ms;
  }
`;

export const StyledFooterContacts = styled(StyledFooterContent)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-style: normal;
  & .socials--desktop {
    margin-bottom: 6px;
  }
  @media screen and (min-width: ${S.tablet}) {
    flex-direction: column;
    align-items: flex-start;
    & .socials--desktop {
      margin-top: 22px;
    }
  }
`;

export const StyledFooterContactsWrapper = styled.ul`
  & > li {
    line-height: 2.2em;
    font-size: 14px;
    @media screen and (min-width: ${S.tablet}) {
      font-size: 16px;
    }
  }
`;

export const StyledCopyright = styled.div`
  margin: 25px -1px;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  color: #cdcdcd;
  text-align: center;
`;
